import { ZAttrMeta } from "src/business/attribute";

import { createValidator } from "./createValidator";
import { MfValidator } from "./MfValidator";
import { createMfRequired } from "./MfValidatorRequired";

export const createValidators = (attrMeta: ZAttrMeta): MfValidator[] => {
  const validators: MfValidator[] = [];
  if (attrMeta.required) {
    validators.push(createMfRequired());
  }
  attrMeta.edit?.rules?.forEach((rule) => {
    validators.push(createValidator(rule));
  });
  return validators;
};
